import React from 'react';
import { Route, IndexRoute } from 'react-router';
import App from './App';
import * as Auth from './components/common/authentication/';
import * as Layouts from './layouts';
import * as SitePages from './components/site/pages';
import ExternalEndorsementForm from '../client/components/site/features/profile/elements/forms/ExternalEndorsementForm';


export default (
	<Route>
		{/*<Route path="/payment-confirmation" component={SitePages.PaymentConfirmation}/>*/}
		<Route path="/endorsement-form" component={ExternalEndorsementForm} />
		<Route component={App}>
			<Route path="/login" component={Auth.Login} />
			{/*<Route path="/register" component={Auth.Register} />*/}
			<Route path="/password-reset" component={ Auth.ForgotPassword }/>
			<Route path="/password-change" component={ Auth.PasswordChange }/>
			{/*<Route path="/offer-page" component={SitePages.OfferPage}/>*/}

			<Route component={Auth.AuthCheck}>
				{/*<Route component={Auth.NetworkCheck}>*/}
				<Route path="/">
					<Route component={Layouts.SiteLayout}>
						<Route path="legal/cookies" component={SitePages.CookiesPage} />
						<Route path="legal/terms" component={SitePages.TermsPage} />
						<Route path="legal/development-products-terms" component={SitePages.DPTermsPage} />
						<Route path="legal/privacy" component={SitePages.PrivacyPage} />
						<Route
							path="/account"
							component={SitePages.AccountSettings.AccountSettingsMainPage}
						>
							<Route
								path="basic"
								component={SitePages.AccountSettings.BasicSettingsPage}
							/>
							<Route
								path="transaction-history"
								component={SitePages.NotFound}
							/>
							<Route
								path="previous-transaction-history"
								component={
									SitePages.AccountSettings.TransactionHistorySettingsPage
								}
							/>
							<Route
								path="preferences"
								component={SitePages.AccountSettings.PreferenceSettingsMainPage}
							/>
							<Route
								path="transaction-receipt/:transactionId"
								component={SitePages.AccountSettings.TransactionReceipt}
							/>
							<Route
								path="transaction-receipt/:transactionId/print"
								component={SitePages.AccountSettings.FullVatReceipt}
							/>
							<Route
								path="jobs-and-member-preferences"
								component={SitePages.JobsPages.JobPreferences}
							/>
							<Route
								path="location-preferences"
								component={SitePages.AccountSettings.LocationPreferences}
							/>
						</Route>
						<IndexRoute component={SitePages.ITNHomepage} />
						{/*TODO THE TOUR NEEDS TO BE REDONE*/}
						{/*<Route path="take-the-tour" component={SitePages.TakeTour}/>*/}
						<Route path="basket" component={SitePages.BasketPage} />
						<Route path="checkout" component={SitePages.CheckoutPage} />
						<Route path="checkout/payment" component={SitePages.PaymentPage} />
						<Route
							path="/expired"
							component={SitePages.PurchasesPages.ITNPackagePage}
						/>
						{/*<Route path="legal/cookies" component={SitePages.CookiesPage} />*/}
						{/*<Route path="legal/terms" component={SitePages.TermsPage} />*/}
						//temporarily being replaced by external zendesk link
						{/*<Route component={SitePages.Help.HelpPage}>*/}
						{/*<Route path="help/faq" component={SitePages.Help.FaqPage}/>*/}
						{/*<Route path="help/contact" component={SitePages.Help.ContactPage}/>*/}
						{/*</Route>*/}
						<Route path="my-jobs-section" component={SitePages.JobsLayout}>
							<Route
								path="favourite-jobs"
								component={SitePages.JobsPages.JobFavourites}
							/>
							<Route
								path="saved-searches"
								component={SitePages.JobsPages.SavedSearchPage}
							/>
							<Route
								path="my-applications"
								component={SitePages.JobsPages.JobApplications}
							/>
						</Route>
						<Route path="my-jobs" component={SitePages.JobsPages.MyJobsPage} />
						<Route path="stars" component={SitePages.StarsPage} />
						<Route path="contact-us" component={SitePages.ContactPage} />
						<Route path="jobs">
							{/*<Route path="favourites" component={SitePages.JobsPages.JobFavourites}/>*/}
							{/*<Route path="saved-searches" component={ SitePages.JobsPages.SavedSearchPage }/>*/}
							{/*<Route path="my-applications" component={ SitePages.JobsPages.JobApplications }/>*/}

							<IndexRoute component={SitePages.JobsPages.JobsPage} />
							<Route
								path=":jobId"
								page="individual-job"
								component={SitePages.JobsPages.JobFullView}
							/>
							<Route
								path=":jobId/apply"
								component={SitePages.JobsPages.JobApplication}
							/>
						</Route>
						<Route path="members" page="members">
							<IndexRoute component={SitePages.MembersPages.MemberPage} />
							<Route
								path=":memberId"
								page="individual-member"
								component={SitePages.Profile}
							/>
						</Route>
						<Route path="training" page="training">
							<Route path="courses" page="courses">
								<IndexRoute component={SitePages.CoursesPages.CoursesPage} />
								<Route path=":courseId" page="individual-course">
									<IndexRoute
										component={SitePages.CoursesPages.CourseFullView}
									/>
									<Route
										path="modules/:moduleId"
										page="individual-module"
										component={SitePages.CoursesPages.ModuleView}
									/>
								</Route>
							</Route>
							<Route path="interactive-webinars" page="interactive-webinars">
								<IndexRoute component={SitePages.WebinarsPages.WebinarsPage} />
								<Route path=":webinarId" page="individual-course">
									<IndexRoute
										component={SitePages.WebinarsPages.WebinarFullView}/>
								</Route>
							</Route>
							<Route
								path="webinars"
								component={SitePages.BrightTalkWebinarsPage}
								page="webinars"
							/>

							<Route path="podcasts" page="series">
								<IndexRoute
									component={SitePages.PodcastSeriesPage.PodcastSeriesPage}
								/>
								<Route path=":podcastId" page="podcasts">
									<IndexRoute
										component={SitePages.PodcastsPages.PodcastsPage}
									/>
								</Route>
							</Route>
						</Route>
						<Route path="events" page="events">
							<IndexRoute component={SitePages.EventsPage.EventsPage} />
							<Route path=":eventId" page="individual-event">
								<IndexRoute component={SitePages.EventsPage.EventsFullView} />
							</Route>
						</Route>
						<Route path="magazine" component={SitePages.MagazinePage} />
						<Route path="news" component={SitePages.NewsPage} />
						<Route path="profile" component={SitePages.Profile} />
						<Route
							path="writing-services"
							component={SitePages.CvWritingPage}
						/>
						<Route path="blog">
							<IndexRoute component={SitePages.BlogMainPage} />
							<Route path=":uid" component={SitePages.SingleArticlePage} />
						</Route>
						<Route path="testimonials" component={SitePages.TestimonialsPage} />
						<Route
							path="promos"
							component={SitePages.PromotionPages.PromoModalPage}
						/>
						<Route
							path="documents"
							component={SitePages.DocumentsPages.DocumentsPage}
						/>
						<Route path="ask-an-expert" component={SitePages.AskAnExpertPage} />
						<Route path="forums">
							<IndexRoute component={SitePages.ForumPages.Categories} />
							<Route path=":categoryId/threads">
								<IndexRoute component={SitePages.ForumPages.Threads} />
								<Route
									path=":threadId"
									component={SitePages.ForumPages.SingleThread}
								/>
							</Route>
							<Route
								path=":categoryId/create-thread"
								component={SitePages.ForumPages.CreateThread}
							/>
							{/*<Route path="guide" component={SitePages.ForumPages.ForumGuide} />*/}
							{/*<Route path="rules" component={SitePages.ForumPages.ForumRules} />*/}
						</Route>
						<Route
							path="networking/conversations"
							component={SitePages.NetworkingPages.ConversationFullView}
						>
							<Route
								path=":conversationId"
								component={SitePages.NetworkingPages.SingleConversation}
							/>
						</Route>
						{/*<Route path="purchases" component={SitePages.PurchasesPages.ITNPackagePage}/>*/}
						{/*<Route path="bt-settings" component={ BTPage }/>*/}
						<Route path="partnerships-overview">
							<IndexRoute component={SitePages.PartnersCategoryPage} />
							<Route path=":slug" component={SitePages.CMSPage} />
						</Route>
						<Route path="partnerships/:category_name">
							<IndexRoute component={SitePages.PartnersOverviewPage} />
							<Route path=":slug" component={SitePages.CMSPage} />
						</Route>
						<Route path="consultancy">
							<IndexRoute component={SitePages.CorporateOverviewPage} />
							<Route path=":slug" component={SitePages.CMSPage} />
						</Route>
						{//  slices only on dev
						process.env.NODE_ENV && process.env.NODE_ENV === 'development' && (
							<Route path="slices-test-page">
								<IndexRoute component={SitePages.SlicesTestPage} />
							</Route>
						)}
					</Route>
				</Route>
				{/*</Route>*/}
				<Route path="*" component={SitePages.NotFound} />
			</Route>
		</Route>
	</Route>
);



// WEBPACK FOOTER //
// src/client/routes.jsx